import axios from '@core_utils/api/_axios';

// /reg 평가 신청 흐름의 상태. 화면이 무엇을 보여줄지는 아래 값만으로 정해진다.
//   duplicated 가 있으면 → 중복 신청 안내
//   아니면 register_step 1(업체 조회) / 2(정보 입력) / 3(신청 완료 결과)
// 실패는 상태로 두지 않는다 — 실패하면 Step 2 에 머문 채 에러 모달만 띄운다.
const initialState = () => ({
    register_step: 1,
    selected_vendor: null,
    // 서버에 요청이 나가 있는 동안 true. 이 값 하나로 모든 버튼·뒤로가기·로고를 막는다.
    register_loading: false,
    // 이 이메일로 이미 이 프로젝트에 신청돼 있을 때 {message, email}
    duplicated: null,
    // 신청 성공 응답 (Step 3 표시용)
    requested_details: null,
});

const register = {
    namespaced: true,
    state: {
        // 서버(brands DB) 런타임 register 설정 — undefined=미조회, null=없음/실패(코드 기본값 폴백).
        // 화면 초기화(reset)와 무관하게 유지한다.
        remote_register_config: undefined,
        ...initialState(),
    },
    actions: {
        setRegisterStep: ({commit}, register_step) => commit('set', {register_step}),
        setSelectedVendor: ({commit}, selected_vendor) => commit('set', {selected_vendor}),
        setRegisterLoading: ({commit}, register_loading) => commit('set', {register_loading}),
        setDuplicated: ({commit}, duplicated) => commit('set', {duplicated}),
        completeRequest: ({commit}, requested_details) => commit('set', {requested_details, register_step: 3}),
        initiateAllData: ({commit}) => commit('reset'),
        // 테넌트 register 런타임 설정 로드 (1회) — 실패 시 null 로 확정해 코드 기본값 폴백.
        // 엔드포인트 미배포(404)여도 안전 (배포 순서 무관).
        loadTenantRegisterConfig: async ({commit, state}) => {
            if (state.remote_register_config !== undefined) return;
            try {
                const res = await axios.get('/register/tenant-config');
                commit('set', {remote_register_config: (res.data && res.data.register) || null});
            } catch (e) {
                commit('set', {remote_register_config: null});
            }
        }
    },
    mutations: {
        set(state, patch) {
            Object.assign(state, patch);
        },
        reset(state) {
            Object.assign(state, initialState());
        },
    },
};
export default register;
